<template>
  <nav aria-label="Page navigation" v-if="showPagination">
    <ul class="pagination p-0">
      <li class="page-item" :class="{ disabled: !showFirstPage }">
        <a
          class="page-link"
          href="#"
          aria-label="First"
          v-on:click.prevent="goToFirstPage"
        >
          <span aria-hidden="true">&laquo;</span>
        </a>
      </li>
      <li class="page-item" :class="{ disabled: !hasPreviousPage }">
        <a
          class="page-link"
          href="#"
          aria-label="Previous"
          v-on:click.prevent="goToPreviousPage"
        >
          <span aria-hidden="true">&lsaquo;</span>
        </a>
      </li>
      <li class="page-item" v-if="hasPreviousPage">
        <a
          class="page-link"
          href="#"
          v-text="previousPageNumber"
          v-on:click.prevent="goToPreviousPage"
        ></a>
      </li>
      <li class="page-item active">
        <a class="page-link" href="#" v-text="currentPageNumber"></a>
      </li>
      <li class="page-item" v-if="hasNextPage">
        <a
          class="page-link"
          href="#"
          v-text="nextPageNumber"
          v-on:click.prevent="goToNextPage"
        ></a>
      </li>
      <li class="page-item disabled" v-if="showEndElipsis">
        <a class="page-link" href="#">...</a>
      </li>
      <li class="page-item" v-if="showLastPage">
        <a
          class="page-link"
          href="#"
          v-text="lastPageNumber"
          v-on:click.prevent="goToLastPage"
        ></a>
      </li>
      <li class="page-item" :class="{ disabled: !hasNextPage }">
        <a
          class="page-link"
          href="#"
          aria-label="Next"
          v-on:click.prevent="goToNextPage"
        >
          <span aria-hidden="true">&rsaquo;</span>
        </a>
      </li>
      <li class="page-item" :class="{ disabled: !showLastPage }">
        <a
          class="page-link"
          href="#"
          aria-label="Last"
          v-on:click.prevent="goToLastPage"
        >
          <span aria-hidden="true">&raquo;</span>
        </a>
      </li>
    </ul>
  </nav>
</template>
<script>
export default {
  props: {
    data: Object,
    filter: String,
    filterParams: String,
    stage: String,
    params: String
  },

  computed: {
    showLastPage() {
      return this.data.last_page - this.data.current_page > 1;
    },

    showFirstPage() {
      return this.data.current_page > 2;
    },

    showEndElipsis() {
      return this.data.last_page - this.nextPageNumber > 1;
    },

    lastPageNumber() {
      return this.data.last_page;
    },

    currentPageNumber() {
      return this.data.current_page;
    },

    hasNextPage() {
      return !!this.data.next_page_url;
    },

    hasPreviousPage() {
      return !!this.data.prev_page_url;
    },

    nextPageNumber() {
      return this.data.current_page + 1;
    },

    previousPageNumber() {
      return this.data.current_page - 1;
    },

    showPagination() {
      return this.hasPreviousPage || this.hasNextPage;
    }
  },

  methods: {
    goToLastPage() {
      if (this.showLastPage) {
        this.$emit(
          'updateResults',
          this.buildUrlWithFilter(
            this.data.last_page_url,
            this.filter,
            this.filterParams
          )
        );
      }
    },

    goToFirstPage() {
      if (this.showFirstPage) {
        this.$emit(
          'updateResults',
          this.buildUrlWithFilter(
            this.data.first_page_url,
            this.filter,
            this.filterParams
          )
        );
      }
    },

    goToPreviousPage() {
      if (this.hasPreviousPage) {
        this.$emit('updateResults', this.buildPrevPageUrl());
      }
    },

    goToNextPage() {
      if (this.hasNextPage) {
        this.$emit('updateResults', this.buildNextPageUrl());
      }
    },

    buildPrevPageUrl() {
      return this.buildUrlWithFilter(
        this.data.prev_page_url,
        this.filter,
        this.filterParams
      );
    },

    buildNextPageUrl() {
      return this.buildUrlWithFilter(
        this.data.next_page_url,
        this.filter,
        this.filterParams
      );
    },

    buildUrlWithFilter(baseUrl, filter, filterParams) {
      baseUrl = this.setPerPageWithUrl(baseUrl);
      if (this.params) {
        baseUrl = `${baseUrl}${this.params}`;
      }

      if (this.filter) {
        return `${baseUrl}&filter[${filter}]=${filterParams}`;
      }
      return baseUrl;
    },

    buildUrlWithStage(baseUrl, stage) {
      baseUrl = this.setPerPageWithUrl(baseUrl);
      if (this.params) {
        baseUrl = `${baseUrl}${this.params}`;
      }
      return stage ? `${baseUrl}&stage=${stage}` : baseUrl;
    },

    setPerPageWithUrl(baseUrl) {
      if (this.data.per_page) {
        return `${baseUrl}&per_page=${this.data.per_page}`;
      }

      return `${baseUrl}&per_page=${this.perPage}`;
    }
  }
};
</script>
